module.exports = __webpack_public_path__ + "images/frontpage_autoplay@2x.png?0d576fe9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_autoplay@2x.png
// module id = 628
// module chunks = 7